export default "__VITE_ASSET__DfHRCPUC__"